import { render, staticRenderFns } from "./Discount_SubForm.vue?vue&type=template&id=53a438a2&"
import script from "./Discount_SubForm.vue?vue&type=script&lang=js&"
export * from "./Discount_SubForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports